export const colorPalette = [
	'#CA498C', '#CE3452', '#DF634F',
	'#F0C350', '#6CB1C8', '#387C89',
	'#4C485F', '#60BB78', '#96BEA1',
	'#D1BA7C',
	'#71a49f', '#86b4d6', '#799bc6',
	'#6c81b7', '#837a9c', '#9c7282',
	'#e6bd75', '#99b965', '#4e6b68',
	'#7266a0'
]


